import { render, staticRenderFns } from "./TechnologyFileBrowse.vue?vue&type=template&id=1264c6be&scoped=true&"
import script from "./TechnologyFileBrowse.vue?vue&type=script&lang=js&"
export * from "./TechnologyFileBrowse.vue?vue&type=script&lang=js&"
import style0 from "./TechnologyFileBrowse.vue?vue&type=style&index=0&id=1264c6be&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1264c6be",
  null
  
)

export default component.exports